module.exports = __webpack_public_path__ + "static/img_4341-2b60e0a7d08835d2e1e1c4516adf28b4.webp";